<template>
  <div class="content-box">
    <div class="element-wrapper">
      <router-link class="btn btn-dark" :to="{ name: 'wms-agenda-nuevo', params: {} }">
        Añadir Nuevo
        <i class="fas fa-plus"></i>
      </router-link>
      <br /><br />
      <div class="element-box" >
        <h5 class="form-header">Agenda de Proveedores</h5>
        <div style="padding: 0px;" class="col-sm-5"><AgendaProveedorComponent /></div>
      </div>
    </div>
    <div class="element-box" style="text-align: left">
      <h6 class="form-header">Próximos Eventos:</h6>
      <table class="table table-lightborder">
        <tbody>
          <td class="text-left bolder nowrap">
            <span class="text-dark" style="font-size: 85%">{{ current }}</span>
          </td>
        </tbody>
      </table>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalVerEventoAgenda"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Evento de Agenda</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Proveedor:</label>&nbsp;&nbsp;
                  <b
                    ><label v-if="current_event.proveedor_obj"
                      >{{ current_event.proveedor_obj.codigo }} -
                      {{ current_event.proveedor_obj.nombre }}</label
                    ></b
                  >
                </div>
                <div class="form-group">
                  <label>Creador:</label>&nbsp;&nbsp;
                  <b
                    ><label v-if="current_event.usuario_crea_obj"
                      >{{ current_event.usuario_crea_obj.username }} -
                      {{ current_event.usuario_crea_obj.name }}</label
                    ></b
                  >
                </div>
                <div class="form-group">
                  <label>Asignado a:</label>&nbsp;&nbsp;
                  <b
                    ><label v-if="current_event.usuario_obj"
                      >{{ current_event.usuario_obj.username }} -
                      {{ current_event.usuario_obj.name }}</label
                    ></b
                  >
                </div>
                <div class="form-group">
                  <label>Rampa:</label>&nbsp;&nbsp;
                  <label v-if="current_event.rampa_obj">{{
                    current_event.rampa_obj.identificador
                  }}</label>
                  <label v-if="!current_event.rampa_obj">Sin Rampa asignada</label>
                </div>
              </div>
            </form>
            <div class="element-box" style="text-align: center"></div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" type="button" @click="iniciarRecepcion">
              Crear Recepción
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import AgendaProveedoresService from "@/services/wms/AgendaProveedoresService";
import RecepcionService from "@/services/wms/RecepcionService";
import AgendaProveedorComponent from "@/components/wms/agenda/AgendaProveedorComponent";

let eventGuid = 0;
let todayStr = new Date().toISOString().replace(/T.*$/, ""); // YYYY-MM-DD of today

export default {
  
  components: {
    ProveedoresSelectComponent,
    AgendaProveedorComponent
  },
  data() {
    return {
      current: {},
      calendarOptions: {

        selectable: {
          // habilita la selección de fechas con un toque
          dateSelecting: true,
          // habilita el arrastre de eventos con un toque
          eventDragging: true,
        },

        dateClick: this.handleDateClick,
        dateSelecting: this.handleDateClick,
        headerToolbar: {
          left: "",
          center: "title",
          right: "",
        },

        footerToolbar: {
          left: "dayGridMonth,timeGridWeek,timeGridDay",
          center: "today",
          right: "prev,next",
        },

        initialView: "dayGridMonth",
        initialEvents: {}, // alternatively, use the `events` setting to fetch from a feed
        editable: false,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        datesSet: this.changeDatesSet,
        events: [],
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },

      eventos_actuales: [],
      current_event: {
        proveedor: {
          errors: {},
        },
        proveedor_obj: {},
        errors: {},
      },
    };
  },
  computed: {},
  mounted() {
    FullCalendar.use(interactionPlugin);
  },
  methods: {
    changeDatesSet: function (dateinfo) {
      let start_date = dateinfo.startStr;
      let end_date = dateinfo.endStr;
      this.refreshAgenda(start_date, end_date);
    },
    refreshAgenda(start, end) {
      let self = this;
      AgendaProveedoresService.fetch({
        fecha_de__gte: start,
        fecha_a__lte: end,
        quitar_paginacion: "true",
      })
        .then((response) => {
          self.eventos_actuales = response.data;
          self.refreshEventos();
        })
        .catch((error) => {
          Notifications.alert.error("No se ha podido realizar la acción", error.response);
        });
    },
    refreshEventos() {
      let events = [];
      let self = this;
      self.calendarOptions.events = [];
      self.eventos_actuales.forEach((value, key) => {
        let current = Object.assign({}, value);
        current.start = current.fecha_de;
        current.end = current.fecha_a;
        self.calendarOptions.events.push({
          id: current.id,
          title: current.proveedor,
          start: current.fecha_de,
          end: current.fecha_a,
          allDay: false,
        });
      });
    },

    createEventId() {
      return String(eventGuid++);
    },
    handleDateSelect(selectInfo) {
      alert(selectInfo);
      console.log(selectInfo);
      let calendarApi = selectInfo.view.calendar;
      calendarApi.unselect(); // clear date selection
      return;
      if (title) {
        calendarApi.addEvent({
          id: 111,
          title,
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay,
        });
      }
    },
    handleEventClick(clickInfo) {
      let self = this;
      let id = clickInfo.event.id;
      AgendaProveedoresService.getById(id).then((res) => {
        self.current_event = { ...res.data, ...{ errors: {} } };
        $("#modalVerEventoAgenda").modal();
      });

      self.$router.push({
        name: "wms-agenda-nuevo",
        params: { id: self.current.id },
      });
      /*if (
        confirm(
          `Are you sure you want to delete the event '${clickInfo.event.title}'`
        )
      ) {
        clickInfo.event.remove();
      }*/
    },
    handleEvents(events) {
      this.eventos_actuales = events;
    },

    iniciarRecepcion() {
      let self = this;
      let agendaProveedor = self.current_event;
      RecepcionService.save({
        tienda: agendaProveedor.rampa_obj.tienda,
        agenda_proveedor: agendaProveedor.id,
        proveedor: agendaProveedor.proveedor,
        rampa: agendaProveedor.rampa,
      })
        .then((response) => {
          self.$router.push({
            name: "wms-recepcion-editar",
            params: {
              id: response.data.id,
            },
          });
          // self.refreshCurrent();
          // document.location.reload();
        })
        .catch((error) => {
          console.log(error.response.data);
          self.current_event.errors = error.response.data;
        });
    },
  },
};
</script>
